import { getString } from "../common/common";

export const CUSTOMER_DETAILS = "CUSTOMER_DETAILS";
export const PASSENGER_DETAIL = "PASSENGER_DETAIL";
export const CONTINUE_AS_GUEST = "CONTINUE_AS_GUEST";
export const LOGIN = "LOGIN";
export const YOUR_IP_ADDRESS = "YOUR_IP_ADDRESS";
export const COUNTRY_CODE = "COUNTRY_CODE";
export const MOBILE_NUMBER = "MOBILE_NUMBER";
export const EMAILID = "EMAILID";
export const PROCEED_TPDA = "PROCEED_TPDA";
export const GUEST = "GUEST";
export const USER = "USER";
export const ONWARD_TRIP_PASSENGER = "ONWARD_TRIP_PASSENGER";
export const ONWARD_TRIP_PASSENGERS = "ONWARD_TRIP_PASSENGERS";
export const RETURN_TRIP_PASSENGER = "RETURN_TRIP_PASSENGER";
export const RETURN_TRIP_PASSENGERS = "RETURN_TRIP_PASSENGERS";
export const NAME = "NAME";
export const GENDER = "GENDER";
export const AGE = "AGE";
export const CONCESSION = "CONCESSION";
export const IDCARD = "IDCARD";
export const IDCARDNO = "IDCARDNO";
export const COUNTRY = "COUNTRY";
export const PROCEES_TO_CHECKOUT = "PROCEES_TO_CHECKOUT";
export const VALID_LOGIN_DETAILS = "VALID_LOGIN_DETAILS";
export const KINDLY_ENTER = "KINDLY_ENTER";
export const PASSWORD = "PASSWORD";

export const translations = {
  en: {
    [CUSTOMER_DETAILS]: "Customer Details",
    [PASSENGER_DETAIL]: "Passenger Detail",
    [CONTINUE_AS_GUEST]: "Continue As Guest",
    [LOGIN]: "Login",
    [YOUR_IP_ADDRESS]: "Your IP Address",
    [COUNTRY_CODE]: "Country Code",
    [MOBILE_NUMBER]: "Mobile No",
    [EMAILID]: "Email ID",
    [PROCEED_TPDA]: "PROCEED TO passenger detail as",
    [GUEST]: "guest",
    [USER]: "user",
    [ONWARD_TRIP_PASSENGER]: "Onward Trip Passenger",
    [ONWARD_TRIP_PASSENGERS]: "Onward Trip Passengers",
    [RETURN_TRIP_PASSENGER]: "Return Trip Passenger",
    [RETURN_TRIP_PASSENGERS]: "Return Trip Passengers",
    [NAME]: "Name",
    [GENDER]: "Gender",
    [AGE]: "Age",
    [CONCESSION]: "Concession",
    [IDCARD]: "Id Card",
    [IDCARDNO]: "Id card No",
    [COUNTRY]: "Country",
    [PROCEES_TO_CHECKOUT]: "Proceed to Checkout",
    [VALID_LOGIN_DETAILS]: "Please enter valid login details",
    [KINDLY_ENTER]: "Kindly enter",
    [PASSWORD]: "Password",
  },
  kn: {
    [CUSTOMER_DETAILS]: "ಗ್ರಾಹಕರ ವಿವರಗಳು",
    [PASSENGER_DETAIL]: "ಪ್ರಯಾಣಿಕರ ವಿವರಗಳು",
    [CONTINUE_AS_GUEST]: "ಅತಿಥಿ ಬಳಕೆದಾರರಾಗಿ ಮುಂದುವರಿಯಿರಿ",
    [LOGIN]: "ಲಾಗ್‍ಇನ್",
    [YOUR_IP_ADDRESS]: "ನಿಮ್ಮ IP ವಿಳಾಸ",
    [COUNTRY_CODE]: "ದೇಶದ ಕೋಡ್",
    [MOBILE_NUMBER]: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ.",
    [EMAILID]: "ಇಮೇಲ್ ಐಡಿ",
    [PROCEED_TPDA]: "ಪ್ರಯಾಣಿಕರ ವಿವರಗಳಿಗೆ ಮುಂದುವರಿಯಿರಿ",
    [GUEST]: "ಅತಿಥಿ",
    [USER]: "ಬಳಕೆದಾರ",
    [ONWARD_TRIP_PASSENGER]: "ಪ್ರಯಾಣಿಕರ ವಿವರಗಳು",
    [ONWARD_TRIP_PASSENGERS]: "ಪ್ರಯಾಣಿಕರ ವಿವರಗಳು",
    [RETURN_TRIP_PASSENGER]: "ಪ್ರಯಾಣಿಕರ ವಿವರಗಳು",
    [RETURN_TRIP_PASSENGERS]: "ಪ್ರಯಾಣಿಕರ ವಿವರಗಳು",
    [NAME]: "ಹೆಸರು",
    [GENDER]: "ಲಿಂಗ",
    [AGE]: "ವಯಸ್ಸು",
    [CONCESSION]: "ರಿಯಾಯಿತಿ",
    [IDCARD]: "ಗುರುತಿನ ಚೀಟಿ",
    [IDCARDNO]: "ಗುರುತಿನ ಚೀಟಿ ನಂಬರ್",
    [COUNTRY]: "ದೇಶ",
    [PROCEES_TO_CHECKOUT]: "ಚೆಕ್ಔಟ್ ಗೆ ಮುಂದುವರಿಯಿರಿ",
    [VALID_LOGIN_DETAILS]: "ದಯವಿಟ್ಟು ಸರಿಯಾದ ಲಾಗಿನ್ ವಿವರಗಳನ್ನು ಎಂಟರ್ ಮಾಡಿ",
    [KINDLY_ENTER]: "ದಯವಿಟ್ಟು ಎಂಟರ್ ಮಾಡಿ",
    [PASSWORD]: "ಗುಪ್ತಪದ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
